import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Text1 = styled.div`
  display: block;
  font-family: Avenir Next;
  font-size: 22px;
  margin-top: 155px;
  margin-bottom: 14px;
`;

export const RedText = styled.div`
  font-size: 63px;
  color: red;
`;

export const Text2 = styled.div`
  display: flex;
  font-family: Cormorant Infant;
  font-size: 68px;
  text-align: center;
  align-items: center;
  gap: 17px;
  margin-bottom: 36px;
`;

export const Text3 = styled.div`
  display: block;
  font-family: Avenir Next;
  font-size: 25px;
  text-align: center;
  margin-bottom: 36px;
`;
